import { CheckBoxContainerVariantType } from '../../../../../../components/checkboxContainer/types/checkboxContainer';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
export const getRegularStyles = (FOUNDATIONS, FONT) => {
    return {
        [CheckBoxContainerVariantType.REGULAR]: {
            container: { display: 'flex', flex_direction: 'column', gap: FOUNDATIONS.spacing_150 },
            containerList: { display: 'flex', flex_direction: 'column', gap: FOUNDATIONS.spacing_250 },
            title: {
                color: FOUNDATIONS.color_neutral_font_50,
                font_weight: FONT_WEIGHT.font_weight_600,
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
            },
        },
    };
};
//# sourceMappingURL=regular.js.map